export default __webpack_public_path__ + "assets/img/profile.c62f8a5b.jpg";